import CloseIcon from 'svg/CloseIcon';
import { Button, ButtonText } from 'components/Button';
import Modal from 'components/modals/Modal';

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  onDelete: () => void;
  eventTitle: string;
  isLoading?: boolean;
}

export default function ModalDeleteEvent({
  isOpen,
  closeModal,
  onDelete,
  eventTitle,
  isLoading = false,
}: Props) {
  return (
    <Modal isOpen={isOpen} handleClose={closeModal}>
      <div className="flex flex-col justify-between gap-8 px-6 pb-5 pt-6">
        <div className="flex flex-row justify-between text-left">
          <h3 className="typography-product-heading-compact text-left text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            Delete Tournament
          </h3>
          <ButtonText onClick={closeModal}>
            <CloseIcon className="h-6 w-6" />
          </ButtonText>
        </div>
        <div className="space-y-4">
          <p className="typography-product-body font-normal text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            Are you sure you want to delete "{eventTitle}"? This action cannot be undone.
          </p>
          <p className="typography-product-caption text-color-error-500 dark:text-color-error-400">
            All tournament data, registrations, and associated information will be permanently
            removed.
          </p>
        </div>
        <div className="flex w-full gap-4">
          <Button
            variant="inverted"
            className="w-full"
            size="lg"
            onClick={closeModal}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="lg"
            className="w-full"
            onClick={onDelete}
            loading={isLoading}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
}
